export const content = {
  THEMA_TOOLTIP: 'Nach Themen suchen in den Feldern "Titel", "AKA-Produkt-ID", "BNR", "V-Nummer", oder "AKA-Modul-ID"',
  VERANSTALTUNG_TOOLTIP:
    'Nach Veranstaltungen suchen in den Feldern "Titel", "AKA-Veranstaltung-ID", "SAP-E-ID", "BNR", "V-Nummer" oder "AKA-Modul-ID"',
} as const;
